import { render } from "./TheFooter.vue?vue&type=template&id=a9c3fba6"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"
script.render = render

export default script